import { Component, OnInit, Input } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from '../../filtre.service';
import { pairwise, startWith, distinctUntilChanged } from 'rxjs/operators';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class TimeInputComponent extends InputComponent implements OnInit {

  @Input()
  classeSupplementaire: string = '';

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
  ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  ngOnInit() {
    super.ngOnInit();
    // Comme toujours avec les subscriptions, ne pas oublier de fermer les ressources
    // Cela est fait automatiquement par la classe mère via subTab
    this.subTab.push(
      this.currentControl.valueChanges
        // récupération de la valeur précédente
        .pipe(distinctUntilChanged(), startWith(''), pairwise())
        .subscribe(([avant, apres]) => {
          const validationChaine: RegExp = new RegExp('^[0-9]{0,2}(:([0-5]{0,1}|[0-5][0-9]{0,1})){0,1}$');
          if (apres) {
            const valueString = apres.toString();
            if (validationChaine.test(valueString)) {
              if (valueString.length === 2 && validationChaine.test(valueString + ':')) {
                this.currentControl.patchValue(valueString + ':', { emitEvent: false });
              }
            } else {

              this.currentControl.patchValue(avant, { emitEvent: true });
            }
          }
        })
    );
    // On force la mise à jour des valeurs
    this.currentControl.updateValueAndValidity();
  }

}
